import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'truncate',
  standalone: false,
  pure: true,
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, minLength = 0, maxLength = 30): string {
    if (!value) return '';
    return value.length > maxLength ? value.slice(minLength, maxLength) + '...' : value;
  }
}
